import ActualTrucks from './ActualTrucks';

export default ActualTrucks;
